import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TextField, Typography, Box, Alert, Paper } from '@mui/material';
import API_ENDPOINTS from '../config/apiConfig';
import { useTranslation } from '../i18n/i18n';
import LoadingButton from './LoadingButton';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ResetPassword = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const token = query.get('token');
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!newPassword || !confirmPassword) {
      setError(t('fields_required'));
      return;
    }
    if (newPassword !== confirmPassword) {
      setError(t('reset_mismatch'));
      return;
    }
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
    if (!passwordRegex.test(newPassword)) {
      setError(t('changepassword_error_password_strength'));
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(API_ENDPOINTS.BASEURL + '/api/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: newPassword })
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(data && data.message ? t(data.message) : t('reset_success'));
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setError(data && data.message ? t(data.message) : t('reset_error'));
      }
    } catch (err) {
  setError(t('reset_error'));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return <Alert severity="error">{t('reset_token_error')}</Alert>;
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh" px={{ xs: 2, sm: 0 }}>
      <Paper elevation={3} sx={{ p: { xs: 2.5, sm: 4 }, width: '100%', maxWidth: 480, minWidth: { sm: 320 } }}>
        <Typography variant="h5" gutterBottom>{t('reset_title')}</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField
            label={t('reset_new_password')}
            type="password"
            fullWidth
            margin="normal"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            required
          />
          <TextField
            label={t('reset_confirm_password')}
            type="password"
            fullWidth
            margin="normal"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
          />
          <LoadingButton
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            loading={loading}
            loadingLabel={t('reset_loading')}
            sx={{ mt: 2 }}
          >
            {t('reset_button')}
          </LoadingButton>
        </form>
      </Paper>
    </Box>
  );
};

export default ResetPassword;
